/**
 * created by JUNO Peng 1/8/2024.
 * Description:
 *        system config with server.
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../tamalelibs/models/app-config.model';
import { TransportService } from '../tamalelibs/services/transport.service';


@Injectable({
    providedIn: 'root'
})
export class SystemConfigService {
    constructor(
        private _transportService: TransportService,
    ) { }


    public getSystemConfig(): Observable<any> {
        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            'Pragma': 'no-cache'
        };
        const url = `${AppConfig.systemConfig}`;
        const options = {
            headers: headers,
        };
        return this._transportService.get(url, options);
    }

    public putSystemConfig(systemConfig): Observable<any> {
        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            'Pragma': 'no-cache'
        };
        const url = `${AppConfig.systemConfig}`;
        const options = {
            headers: headers,
        };

        const formData = new URLSearchParams();

        formData.set('systemConfig', JSON.stringify(systemConfig));
        return this._transportService.put(url, formData.toString(), options);
    }


    public changeSystemStatus(systemAction): Observable<any> {
        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            'Pragma': 'no-cache'
        };
        const url = `${AppConfig.systemConfig}/runcommand`;
        const options = {
            headers: headers,
        };

        const formData = new URLSearchParams();

        formData.set('systemAction', systemAction);
        return this._transportService.post(url, formData.toString(), options);
    }

}
